import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

// True when the signed-in user is on the no-card "limited trial" tier. Resource actions that are
// locked on the trial (see the trial capability matrix: extra volumes/networks, snapshots, backups,
// load balancers, clusters, and managed MySQL/MariaDB/Redis/Qdrant/ClickHouse) should be disabled
// for these users. Compute (VM up to m1.medium) and managed Postgres stay available.
export const useLimitedTrial = (): boolean =>
    useSelector((state: RootState) => state.billingForecast.forecast?.tier === 'trial_no_card');
